import { Button, Center, CloseButton, Flex, Grid, Input, Select, Text, Textarea, TextInput } from '@mantine/core'
import { IconSearch } from '@tabler/icons-react'
import { useMutation, useQuery } from '@tanstack/react-query'
import { getAllDataWithFilters, getPaymentDetails, updateRecord } from '../../services/common.service'
import { useState } from 'react'
import { displayNotification } from '../../commonComponents/notifications/displayNotification'
import { compareObject } from '../../utils/objectManuplation.utils'

const PaymentRecovery = () => {
    const [TransactionId, setTransactionId] = useState('')
    const [data, setData] = useState([])
    const [original, setOriginal] = useState([])
    const [result, setResult] = useState()

    const getPaymentMutate = useMutation({
        mutationFn: ({ TransactionId }) => {
            return getPaymentDetails({
                filters: `transaction_id='${TransactionId}'`
            });
        },
        onSuccess: async (res) => {
            setData({...res?.data[0]});
            setOriginal({...res?.data[0]});
            setResult(true)
        },
        onError: (e) => {
            console.log("Error", e)
            setData()
            setResult(true)
        },
        gcTime: 0
    })

    const updatePaymentQuery = useMutation({
        mutationFn: (body) => updateRecord({ source: "mswipe_transaction_history", body }),
        onSuccess: () => {
            displayNotification({
                message: "Payment updated successfully",
                title: "Success",
                variant: "success"
            })
            setData()
            setTransactionId("")
            setResult(false)
        },
        onError: () => {
            displayNotification({
                message: "Something went wrong",
                title: "Error",
                variant: "error"
            })
        },
        gcTime: 0
    })

    const getTerminalsQuery = useQuery({
        queryKey: ['mswipe transaction response code'],
        queryFn: () => getAllDataWithFilters({
            page: -1,
            source: 'mswipe_transaction_response_code',
            filter: [{ key: "response_code", value: "cst", condition: "icontains" }],
            sort: [{ id: 'description', desc: false }]
        }),
        select: (data) => {
            let result = data?.data?.map(item => ({
                label: item?.description,
                value: item?.response_code
            }))
            return { ...data, data: result }
        },
        gcTime: 0
    })

    const handleTransactionData = (text) => {
        setTransactionId(text?.target?.value)
        setResult(false)
    }

    const handleSearch = () => {
        if (!TransactionId) {
            return
        }
        getPaymentMutate.mutate({ TransactionId })
    }

    const handleUpdate = () => {
        if (data?.response_code == 'CST4' && !data?.support_notes?.trim()?.length) {
            displayNotification({
                message: "Please enter support notes",
                title: "Error",
                variant: "error"
            })
        } else {
            const body = {
                id: data?.mswipe_txn_id,
                support_notes: data?.support_notes,
                response_code: data?.response_code,
                support_reference_number: data?.support_reference_number
            }
            updatePaymentQuery.mutate(body)
        }
    }

    return (
        <div>
            <Flex
                mih={50}
                gap="md"
                justify="flex-start"
                align="center"
                direction="row"
                wrap="wrap"
            >
                <Text size='xl' fw={600}>Payment Recovery</Text>
                <Input
                    w={380}
                    value={TransactionId}
                    rightSectionPointerEvents="all"
                    mt={'6px'}
                    rightSection={
                        <CloseButton
                            onClick={() => {
                                setTransactionId('')
                                setData({})
                                setResult(false)
                            }}
                            style={{ display: TransactionId ? undefined : 'none' }}
                        />
                    }
                    onKeyDown={(event) => event.key === 'Enter' && handleSearch()}
                    placeholder="Type or paste Transaction ID here"
                    leftSection={<IconSearch size={16} />}
                    onChange={handleTransactionData} />
                <Button variant="filled" size='xs' mt={'6px'} onClick={handleSearch} loading={getPaymentMutate.isPending}>Search</Button>
            </Flex>
            <Grid mt={'md'}>
                {Object.keys(data || {}).length > 0 ? (
                    <Grid.Col span={10}>
                        <Grid>
                            <Grid.Col span={3}>
                                <TextInput
                                    label="Journey Date"
                                    value={data?.journey_date}
                                    disabled={true}
                                />
                            </Grid.Col>
                            <Grid.Col span={3}>
                                <TextInput
                                    label="Flight Number"
                                    value={data?.flight_number}
                                    placeholder="Type or paste Transaction ID here"
                                    disabled={true}
                                />
                            </Grid.Col>
                            <Grid.Col span={2}>
                                <TextInput
                                    label="Sector Pattern"
                                    value={data?.sector_pattern}
                                    placeholder="Type or paste Transaction ID here"
                                    disabled={true}
                                />
                            </Grid.Col>
                            <Grid.Col span={2}>
                                <TextInput
                                    label="From"
                                    value={data?.from}
                                    placeholder="Type or paste Transaction ID here"
                                    disabled={true}
                                />
                            </Grid.Col>
                            <Grid.Col span={2}>
                                <TextInput
                                    label="To"
                                    value={data?.to}
                                    placeholder="Type or paste Transaction ID here"
                                    disabled={true}
                                />
                            </Grid.Col>

                            <Grid.Col span={3}>
                                <TextInput
                                    label="Seat"
                                    value={data?.seat}
                                    disabled={true}
                                />
                            </Grid.Col>
                            <Grid.Col span={3}>
                                <TextInput
                                    label="Pnr"
                                    value={data?.flight_number}
                                    disabled={true}
                                />
                            </Grid.Col>
                            <Grid.Col span={2}>
                                <TextInput
                                    label="Paid Amount"
                                    value={data?.transaction_amount}
                                    disabled={true}
                                />
                            </Grid.Col>
                            <Grid.Col span={2}>
                                <TextInput
                                    label="Payment Mode"
                                    value={data?.payment_mode}
                                    disabled={true}
                                />
                            </Grid.Col>
                            <Grid.Col span={2}>
                                <TextInput
                                    label="Paid at"
                                    value={data?.payment_tried_at}
                                    placeholder="Type or paste Transaction ID here"
                                    disabled={true}
                                />
                            </Grid.Col>

                            <Grid.Col span={6}>
                                <TextInput
                                    label="Transaction ID"
                                    value={data?.transaction_id}
                                    disabled={true}
                                />
                            </Grid.Col>
                            <Grid.Col span={4}>
                                <Select
                                    data={getTerminalsQuery?.data?.data}
                                    placeholder="Select transaction"
                                    label="Transaction Description"
                                    value={data?.response_code}
                                    onChange={(e) => setData({ ...data, response_code: e })}
                                    searchable />
                            </Grid.Col>
                            <Grid.Col span={2}>
                                <TextInput
                                    label="Reference Number"
                                    value={data?.support_reference_number}
                                    placeholder="Enter Reference Number"
                                    onChange={(e) => setData({ ...data, support_reference_number: e?.target?.value })}
                                />
                            </Grid.Col>
                            <Grid.Col span={12}>
                                <Textarea label="Support notes" value={data?.support_notes} placeholder='Enter notes' onChange={(e) => setData({ ...data, support_notes: e.target.value })} />
                            </Grid.Col>
                        </Grid>
                        <Button variant="filled" disabled={compareObject(original, data)} size='xs' mt={'xl'} loading={updatePaymentQuery.isPending} onClick={handleUpdate}>Submit</Button>
                    </Grid.Col>
                ) : (
                    <Center w={'100%'} h={'70vh'}>
                        <Text c={'dimmed'}>
                            {(TransactionId?.length && result) ? 'No data found' : 'Please enter a Transaction ID above to fetch records'}
                        </Text>
                    </Center>
                )}
            </Grid>
        </div>
    )
}

export default PaymentRecovery